import Header from './Headers';

import Config from '../config/config';
import Const from '../util/Constants';

class ActionAPI {

  static list = (success, failure) => {
    fetch(Config.app.link + 'api/custom-action', new Header('GET'))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };

  static get = (id, success, failure) => {
    fetch(Config.app.link + 'api/custom-action/' + id, new Header('GET'))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };

  static save = (action, success, failure) => {
    fetch(Config.app.link + 'api/custom-action', new Header('POST', action))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/custom-action/delete/' + id, new Header('GET'))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };
}
export default ActionAPI;